import { Eye, X } from "lucide-react";
import { useRole } from "@/contexts/RoleContext";

export default function PreviewBanner() {
  const { preview, exitPreview } = useRole();
  if (!preview) return null;
  return (
    <div className="relative z-50 bg-[#FFD600] text-[#0A0A0A]" data-testid="preview-banner">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm font-semibold">
          <Eye size={16} />
          <span>Preview as Client — you're seeing what a new client sees. Nothing here touches real customer data.</span>
        </div>
        <button
          onClick={exitPreview}
          data-testid="exit-preview-button"
          className="shrink-0 bg-[#0A0A0A] text-white px-3 py-1.5 font-mono-label text-[10px] inline-flex items-center gap-1 hover:bg-[#262626] transition-colors"
        >
          <X size={12} /> Exit preview
        </button>
      </div>
    </div>
  );
}
